module.exports = __webpack_public_path__ + "img/smartplug.13b4b460.png";